import { Configuration, LogLevel } from "@azure/msal-browser";

export const internalMsalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_INTERNAL_ENTRA_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_INTERNAL_ENTRA_TENANT_ID}`,
    redirectUri: window.location.origin + "/admin/auth/callback",
    postLogoutRedirectUri: window.location.origin + "/admin/login",
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(`[MSAL Internal] ${message}`);
            return;
          case LogLevel.Warning:
            console.warn(`[MSAL Internal] ${message}`);
            return;
          case LogLevel.Info:
            console.info(`[MSAL Internal] ${message}`);
            return;
        }
      },
    },
  },
};
